<template>
  <div>
    <div class="p-mb-3 p-pt-5">
      <div v-show="activeContainers.length">
      <p>Du må bestille 'Innhent/Avslutte' av resterende {{ activeContainers.length }} container{{ activeContainers.length > 1 ? 'e' : ''}} før prosjektet kan avsluttes.</p>
      </div>
      <Button label="Avslutt prosjekt" class="p-mr-2" @click="setInactive()" :disabled="activeContainers.length > 0"/>
    </div>
  </div>
</template>

<script>

export default {
name: 'projectEnd',


methods: {
  setInactive(){
    this.$confirm.require({
      message: 'Er du sikker på at du vil avslutte prosjektet?',
      header: 'Avslutt',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.$store.dispatch('projects/update', {id: this.project.id, data: {active: false, endedbyadmin: this.isAdmin }}).then(() => {
          this.$toast.add({
            severity:'success',
            summary: 'Avsluttet',
            detail: `${this.project.projectname} er avsluttet`,
            life: 5000,
          })
          this.$router.push({name: 'projects'})
        })
      },
    })
  }
},

computed: {
  isAdmin(){
    return this.$store.getters["user/isAdmin"]
  }, 
  activeContainers(){
    let containers = this.$store.getters["containerOrders/list"]
    if(!containers){
      return []
    }
    return containers.filter(item => item.active)
     
  },
  
  project(){
    return this.$store.getters['projects/inspect']
  }
},


}
</script>